export default "__VITE_ASSET__DA$hl0Y___"